export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/decc719ac0c1523cc2040d71b927dcbc.svg";